import { TextHeader } from '@wallyhealth/web-core'
import styles from './index.module.css'

const HeroSection = () => (
  <div className={styles.container}>
    <div className={styles.body}>
      <TextHeader
        className={styles.header}
        titleClassName={styles.title}
        title="Here's to pearlier pearly whites!"
        subtitle="Open your whitening kit and let's get started."
      />
    </div>
  </div>
)

export default HeroSection
